module.exports = __webpack_public_path__ + "img/P900.688a966b.jpg";